import React, { useEffect, useState } from "react";

import { Collapse, Icon } from 'antd';
import { Button, FormSubmitButton, MasterDetailForm, Widget, useRouter } from '@digital/ui';
import { getChecklistReajuste, getExcelChecklistReajuste, putChecklistReajuste } from "@app/api/sas/relatorioHomologacao";
import { useRecoilValue } from "recoil";
import { ordemCompraIdState } from "../atoms";
import FormTableAbaChecklistReajuste from "./FormTableAbaChecklistReajuste";
import { Visibility } from "@app/components";

interface AbaChecklistReajusteProps {
    ehComprador?: boolean;
}

const AbaChecklistReajuste = ({ ehComprador }: AbaChecklistReajusteProps) => {
    const { history } = useRouter();

    const ordemCompraId = useRecoilValue(ordemCompraIdState);

    const [dataSource, setDataSource] = useState([]);

    useEffect(() => {]
        setDataSource([]);
        getChecklistReajuste(ordemCompraId)
            .then(response => {
                setDataSource(response.checklist);
            });
    }, [history.location]);

    const updateTable = (itens: any) => {
        if (!ordemCompraId) return;
        putChecklistReajuste(ordemCompraId, itens);
    };
    
    return (
        <Collapse
            bordered={false}
            defaultActiveKey="checklist"
            expandIcon={() => <Icon type="arrows-right_4" />}>
            <Collapse.Panel header="Checklist Reajuste" key="checklist">
                <MasterDetailForm>
                    <Widget
                        actions={[
                            <Button
                                type="primary"
                                className="ant-btn-success"
                                icon="files-ms_excel"
                                onClick={() => getExcelChecklistReajuste(ordemCompraId)}>
                                Exportar
                            </Button>,
                            <Visibility
                                visible={ehComprador}
                            >
                                <FormSubmitButton style={{ marginLeft: 10 }} type='primary' noIcon onClick={item => updateTable(item)}>
                                    Salvar
                                </FormSubmitButton>
                            </Visibility>
                        ]}
                    >
                        <FormTableAbaChecklistReajuste dataSource={dataSource} ehComprador={ehComprador} />
                    </Widget>
                </MasterDetailForm>
            </Collapse.Panel>
        </Collapse>
    );
};

export default AbaChecklistReajuste;